module.exports = __webpack_public_path__ + "static/title-64e491bdc343cff8f1c29e79e9859371.png";